"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./ForEngineersElevateCareer.module.css";

export function ForEngineersElevateCareer({
  as: _Component = _Builtin.Section,
}) {
  return (
    <_Component
      className={_utils.cx(_styles, "section-21")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="about-us"
    >
      <_Builtin.BlockContainer
        className={_utils.cx(_styles, "container-46")}
        grid={{
          type: "container",
        }}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-text-align-center-3")}
          tag="div"
        >
          <_Builtin.Heading
            className={_utils.cx(_styles, "homepage-h3")}
            tag="h2"
          >
            {"Simplify Your Business, Elevate Your Career"}
          </_Builtin.Heading>
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-space-medium-2")}
            tag="div"
          />
          <_Builtin.Paragraph className={_utils.cx(_styles, "blogs-subtext")}>
            {
              "By using EngineEars you legitimize your business, automate tasks, and boost your bottom line allowing you to focus on creativity!"
            }
          </_Builtin.Paragraph>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-space-large-3")}
          tag="div"
        />
        <_Builtin.TabsWrapper
          className={_utils.cx(_styles, "tabs")}
          current="Tab 2"
          easing="ease"
          fadeIn={300}
          fadeOut={100}
        >
          <_Builtin.TabsMenu
            className={_utils.cx(_styles, "tabs-menu")}
            tag="div"
          >
            <_Builtin.TabsLink
              className={_utils.cx(_styles, "about-tab")}
              data-w-tab="Tab 1"
              block="inline"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "about-detail-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "h4-heading", "tab-heading")}
                  tag="div"
                >
                  {"Highlight your past work"}
                </_Builtin.Block>
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "small-paragraph",
                    "tab-paragraph"
                  )}
                >
                  {"Showcase your previous work, achievements, and much more."}
                </_Builtin.Paragraph>
              </_Builtin.Block>
            </_Builtin.TabsLink>
            <_Builtin.TabsLink
              className={_utils.cx(_styles, "about-tab")}
              data-w-tab="Tab 2"
              block="inline"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "about-detail-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "h4-heading", "tab-heading")}
                  tag="div"
                >
                  {"Offer specials for clients"}
                </_Builtin.Block>
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "small-paragraph",
                    "tab-paragraph"
                  )}
                >
                  {
                    "Enable promo codes, configure discounts, and specify custom pricing with shareable booking links."
                  }
                </_Builtin.Paragraph>
              </_Builtin.Block>
            </_Builtin.TabsLink>
            <_Builtin.TabsLink
              className={_utils.cx(_styles, "about-tab")}
              data-w-tab="Tab 3"
              block="inline"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "about-detail-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "h4-heading", "tab-heading")}
                  tag="div"
                >
                  {"Visualize your growth"}
                </_Builtin.Block>
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "small-paragraph",
                    "tab-paragraph"
                  )}
                >
                  {
                    "Gain valuable insights into your business with our dashboard enabling you to see growth in projects, revenue, and more!"
                  }
                </_Builtin.Paragraph>
              </_Builtin.Block>
            </_Builtin.TabsLink>
          </_Builtin.TabsMenu>
          <_Builtin.TabsContent
            className={_utils.cx(_styles, "tabs-content")}
            tag="div"
          >
            <_Builtin.TabsPane
              className={_utils.cx(_styles, "tab-content-detail")}
              tag="div"
              data-w-tab="Tab 1"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "tab-content-image")}
                width="auto"
                height="auto"
                loading="lazy"
                alt="Our Mission"
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6744db5a5a5a23f0e5dcd49e_Portfolio-Highlight.gif"
              />
            </_Builtin.TabsPane>
            <_Builtin.TabsPane
              className={_utils.cx(_styles, "tab-content-detail")}
              tag="div"
              data-w-tab="Tab 2"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "tab-content-image")}
                width="auto"
                height="auto"
                loading="lazy"
                alt="Our Vision"
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6744efde8b1146f74d10d9d2_promo-codes-animation.gif"
              />
            </_Builtin.TabsPane>
            <_Builtin.TabsPane
              className={_utils.cx(_styles, "tab-content-detail")}
              tag="div"
              data-w-tab="Tab 3"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "tab-content-image")}
                width="auto"
                height="auto"
                loading="lazy"
                alt="Our Value"
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6744e34ef33a04866b46beac_Dashboard-metrics.gif"
              />
            </_Builtin.TabsPane>
          </_Builtin.TabsContent>
        </_Builtin.TabsWrapper>
      </_Builtin.BlockContainer>
    </_Component>
  );
}
